import { Injectable, inject } from '@angular/core';

import { environment } from '@env';

import { LOCAL_STORAGE } from './tokens';

@Injectable({
  providedIn: 'root'
})
export class LocalStorage {
  private readonly localStorage = inject(LOCAL_STORAGE);

  setItem<T>(key: string, value: T): void {
    if(!this.localStorage) {
      return;
    }

    try {
      this.localStorage.setItem(key, JSON.stringify(value));
    } catch(error) {
      if(environment.production) {
        return;
      }

      if (
        error &&
        ((error as any).name === 'QuotaExceededError' ||
         (error as any).name === 'NS_ERROR_DOM_QUOTA_REACHED')
      ) {
        console.error(`The ${ key } value exceeds the browser storage quota`);
      } else {
        console.error(`Error ocurred while serializing the ${ key } store value, value not updated`);
      }
    }
  }

  getItem<T>(key: string): Partial<T>|null {
    if(!this.localStorage) {
      return null;
    }

    const storedValue: any = this.localStorage.getItem(key);

    if(storedValue === 'undefined' && storedValue === null) {
      return null;
    }

    try {
      return JSON.parse(storedValue) as T;
    } catch {
      return null;
    }
  }
}